// 获取考试答案
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';
export interface IInput {
    _type: number; // 新老考试的区分
    element_id: number;
    question_ids: string;
    student_id?: number;
    user_id?: string;
    is_finished?: number;
}

export const getRightAnswerList = (data: IInput): Promise<IServerQuizAnswerMap> => {
    return fetchData(Api.GET_QUIZ_RIGHT_ANSWER_LIST, data).then((res: IResponse<IServerQuizAnswerMap>) => {
        return res.data;
    });
};
